class AccordionGroup {

  // STATIC

  static init () {
    let _class = this;
    jQuery( '.accordion-group:not(.initialized)' ).each( function () {
      _class.get_instance( this );
    });
  }


  static get_instance ( $element ) {
    $element = jQuery( $element );
    const $group = $element.closest( '.accordion-group' );
    let instance = $group.data( 'AccordionGroup' );
    if ( !instance ) {
      instance = new this( $group );
      $group.data( 'AccordionGroup', instance );
    }
    return instance;
  }

  // static method for external programmatic use
  static toggle_item ( $item, opening = null ) {
    const instance = this.get_instance( $item );
    instance.toggle_item( $item, opening );
  }


  // INSTANCE

  constructor ( $element ) {
    const $group = jQuery( $element );
    if ( !$group.hasClass( 'accordion-group' ) ) {
      console.error( 'Invalid Accordion Group' );
      return;
    }
    this.$group = $group;
    this.$items = jQuery( '> .accordion-item', $element );
    this.active_bg = this.$group.data('bg-active');
    this.inactive_bg = this.$group.data('bg-inactive');

    this.$items.each( function () {
      jQuery( '.accordion-content', this ).css( 'display', jQuery(this).hasClass( 'open' ) ? 'block' : 'none' );
    });

    this.$group.on( 'click', '.accordion-toggle', (e) => {
      const $target = jQuery( e.currentTarget ).closest( '.accordion-item' );
      console.log( this.$items.filter( $target ).length );
      if ( this.$items.filter( $target ).length ) {
        this.toggle_item( $target );
      }
    });

    this.$group.addClass( 'initialized' );
  }


  toggle_item ( $item, opening = null ) {
    $item = jQuery( $item ).closest( '.accordion-item' );
    opening = Boolean( ( opening !== null ) ? opening : !$item.hasClass( 'open' ) );
    const $toggle = jQuery( '.accordion-toggle', $item ).first();
    $toggle.attr( 'aria-expanded', opening ? 'true' : 'false' );
    $item.toggleClass( 'open', opening );
    if ( this.active_bg != this.inactive_bg ) {
      $item
        .toggleClass( `bg-${ this.active_bg }`, opening )
        .toggleClass( `bg-${ this.inactive_bg }`, !opening )
    }
    jQuery( '> .accordion-content', $item )[ opening ? 'slideDown' : 'slideUp' ]( 300 );
  }

}


jQuery( function () {
  AccordionGroup.init();
});